import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useShellUI } from "../context/shellUI";

const Sidebar = () => {
  const location = useLocation()
  const { isMobileOpen, closeMobile, isDesktopCollapsed, toggleDesktopCollapsed } = useShellUI();

  useEffect(() => {
    document.body.classList.toggle('sidebar-collapsed', isDesktopCollapsed);
    return () => document.body.classList.remove('sidebar-collapsed');
  }, [isDesktopCollapsed]);

  useEffect(() => {
    if (!isMobileOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") closeMobile();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isMobileOpen, closeMobile]);

  useEffect(() => {
    if (location.pathname.split("/")[1] == "PrimaryClient") {
      localStorage.setItem('tab', "primary")
    } else if (location.pathname.split("/")[1] == "UserList") {
      localStorage.setItem('tab', "users")
    } else if ((location.pathname.split("/")[1] !== "userInfo") && (location.pathname.split("/")[1] !== "PrimaryClient") && (location.pathname.split("/")[1] !== "UserList")) {

      localStorage.removeItem('tab');
    }
    if (location.pathname.split("/")[1] == "LoadManagement") {
      // setOpenLoad(true)
    } else {
      // setOpenLoad(false)

    }
  }, [location.pathname])


  const navItems = [
    {
      to: "/Home",
      label: "Dashboard",
      isActive: location.pathname === "/Home",
      icon: (
        <img src={require("../assets/images/dashboard.svg").default} alt="" />
      ),
    },
    {
      to: "/company-list",
      label: "Company Management",
      isActive: location.pathname.includes("company-list") || location.pathname.includes("company-info") || location.pathname.includes("agent-list") || location.pathname.includes("agent-knowledgebase"),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-people-fill" viewBox="0 0 16 16">
          <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
        </svg>
      ),
    },
    {
      to: "/allagentlist",
      label: "Agents",
      isActive: location.pathname.includes("allagentlist") || location.pathname.includes("agent-create"),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-robot" viewBox="0 0 16 16">
          <path d="M6 12.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M3 8.062C3 6.76 4.235 5.765 5.53 5.886a26.6 26.6 0 0 0 4.94 0C11.765 5.765 13 6.76 13 8.062v1.157a.933.933 0 0 1-.765.935c-.845.147-2.34.346-4.235.346s-3.39-.2-4.235-.346A.933.933 0 0 1 3 9.219zm4.542-.827a.25.25 0 0 0-.217.068l-.92.9a24.7 24.7 0 0 1-1.871-.183.25.25 0 0 0-.068.495c.55.076 1.232.149 2.02.193a.25.25 0 0 0 .189-.071l.754-.736.847 1.71a.25.25 0 0 0 .404.062l.932-.97a25 25 0 0 0 1.922-.188.25.25 0 0 0-.068-.495c-.538.074-1.207.145-1.98.189a.25.25 0 0 0-.166.076l-.754.785-.842-1.7a.25.25 0 0 0-.187-.135"/>
          <path d="M8.5 1.866a1 1 0 1 0-1 0V3h-2A4.5 4.5 0 0 0 1 7.5V8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1v-.5A4.5 4.5 0 0 0 10.5 3h-2zM14 7.5V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5A3.5 3.5 0 0 1 5.5 4h5A3.5 3.5 0 0 1 14 7.5"/>
        </svg>
      ),
    },
    {
      to: "/assign-numbers",
      label: "Phone Numbers Assign",
      isActive: location.pathname.includes("assign-numbers"),
      icon: (
        <img src={require("../assets/images/phone.svg").default} alt="" />
      ),
    },
    // {
    //   to: "/call-list",
    //   label: "Call List",
    //   isActive: location.pathname.includes("call-list"),
    //   icon: (
    //     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-telephone-fill" viewBox="0 0 16 16">
    //       <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
    //     </svg>
    //   ),
    // },
    // {
    //   to: "/availibility",
    //   label: "Availability  Schedule",
    //   isActive: location.pathname.includes("availibility"),
    //   icon: (
    //     <img src={require("../assets/images/avail.svg").default} alt="" />
    //   ),
    // },
    // {
    //   to: "/appointments",
    //   label: "Appointments",
    //   isActive: location.pathname.includes("appointments"),
    //   icon: (
    //     <img src={require("../assets/images/primary-client.svg").default} alt="" />
    //   ),
    // },
  ];

  return (
    <>
      <div
        className={`sidebar-scrim ${isMobileOpen ? "sidebar-scrim--visible" : ""}`}
        onClick={closeMobile}
        aria-hidden="true"
      />
      <div className="sidebar-overlay">
        <section className={`sidebar ${isMobileOpen ? "sidebar--open" : ""}`}>
          <div className="sidebar-brand">
            {isDesktopCollapsed ? (
              <span className="sidebar-brand-mark" aria-hidden="true">A</span>
            ) : (
              <img
                src={require("../assets/images/avaco-logo.png")}
                alt="Avaco"
                className="sidebar-brand-logo"
              />
            )}
          </div>
          <div className="sidebar-nav">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`sidebar_option ${item.isActive ? "active" : ""}`}
                title={isDesktopCollapsed ? item.label : undefined}
                onClick={closeMobile}
              >
                {item.icon}
                <span className="sidebar_label">{item.label}</span>
                {item.isActive && <span className="sidebar_active-marker" aria-hidden="true" />}
              </Link>
            ))}
          </div>

          <button
            type="button"
            className="sidebar-collapse-btn"
            onClick={toggleDesktopCollapsed}
            aria-label={isDesktopCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={isDesktopCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: isDesktopCollapsed ? "rotate(180deg)" : "none" }}>
              <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span className="sidebar_label">Collapse</span>
          </button>
        </section>
      </div>
    </>
  );
};
export default Sidebar;
